export enum Environment {
  DEV = 'DEV',
  TEST = 'TEST',
  PROD = 'PROD',
}
